import { LikedPayedProfile, Profile } from "@/types/profile";
import { format, isToday, isYesterday } from "date-fns";
import { ru } from 'date-fns/locale';
import { differenceInYearsResult } from "./difference-in-years-result";

export const getSuccessfullVerificationMsg = (name: string | null, gender?: 'male' | 'female'): string => {
    name ??= 'Пользователь';

    if (gender === 'male') {
        return `${name} прошёл проверку`;
    }

    if (gender === 'female') {
        return `${name} прошла проверку`;
    }

    return 'Проверка пройдена';
}

export const travelPlansPlaceholder = 'Хочу наконец перестать откладывать спортзал, купить нормальную подушку и найти человека, который не исчезнет после трёх сообщений'

export const travelPlansLabel = 'Планы на будущее'

export const aboutMePlaceholder =  'Работаю в сфере маркетинга, люблю активные выходные — от настолок с друзьями до спонтанных походов в кино'

export const getUnPayLikeTitleMsg = (
    myGender: 'male' | 'female' | undefined,
    otherGender: 'male' | 'female' | null
): string => {    
    if (!myGender) return '';
    if (!otherGender) return '';
    return [
        'Ты',
        otherGender === 'female' ?
            'ей'
        :
            'ему',
        myGender === 'female' ?
            'понравилась'
        :
            'понравился'
    ]
        .join(' ')
}

export const getDisplayLikeCreatedDate = (date: string): string => {
    if (isToday(date)) {
        return `сегодня в ${format(date, 'HH:mm', { locale: ru })}`;
    }

    if (isYesterday(date)) {
        return `вчера в ${format(date, 'HH:mm', { locale: ru })}`;
    }

    return format(date, "d MMMM 'в' HH:mm", { locale: ru });
};

export const getProfileNameAndAge = (user?: Profile | LikedPayedProfile | null): string => {
    const name = user?.public_name ?? '';
    const age = differenceInYearsResult(user?.dob);

    return name && age ? `${name}, ${age}` : name;
};
